import Vue from 'vue'

import { Validator, default as VeeValidate } from 'vee-validate'
import { sync } from 'vuex-router-sync'
import { on, default as i18next } from 'i18next'
import i18nextLangDetect from 'i18next-browser-languagedetector'
import Vue2Leaflet from 'vue2-leaflet'
import VueScrollTo from 'vue-scrollto'
import messages from '../i18next.json'
import vee_en from './translations/vee-validate/en'
import vee_de from './translations/vee-validate/de'
import vee_pl from './translations/vee-validate/pl'
import vee_da from './translations/vee-validate/da'
import vee_nl from './translations/vee-validate/nl'
import vee_nl_be from './translations/vee-validate/nl_be'
import vee_fr from './translations/vee-validate/fr'
import vee_fr_be from './translations/vee-validate/fr_be'
import vee_hu from './translations/vee-validate/hu'
import vee_es from './translations/vee-validate/es'
import vee_cs from './translations/vee-validate/cs'
import vee_sl from './translations/vee-validate/sl'
import vee_sk from './translations/vee-validate/sk'
import vee_fi from './translations/vee-validate/fi'
import vee_pt from './translations/vee-validate/pt'
import vee_it from './translations/vee-validate/it'
import vee_hr from './translations/vee-validate/hr'
import vee_sv from './translations/vee-validate/sv'
import vee_et from './translations/vee-validate/et'
import vee_lt from './translations/vee-validate/lt'
import vee_lv from './translations/vee-validate/lv'

import App from './components/App'
import router from './router'
import store from './store'

const VueI18Next = require('@panter/vue-i18next')

sync(store, router)

Validator.localize('en', vee_en)
Validator.localize('de', vee_de)
Validator.localize('pl', vee_pl)
Validator.localize('da', vee_da)
Validator.localize('nl', vee_nl)
Validator.localize('nl_be', vee_nl_be)
Validator.localize('fr', vee_fr)
Validator.localize('fr_be', vee_fr_be)
Validator.localize('hu', vee_hu)
Validator.localize('es', vee_es)
Validator.localize('cs', vee_cs)
Validator.localize('sl', vee_sl)
Validator.localize('sk', vee_sk)
Validator.localize('fi', vee_fi)
Validator.localize('pt', vee_pt)
Validator.localize('it', vee_it)
Validator.localize('hr', vee_hr)
Validator.localize('sv', vee_sv)
Validator.localize('et', vee_et)
Validator.localize('lt', vee_lt)
Validator.localize('lv', vee_lv)

Vue.use(VeeValidate)
Vue.use(VueScrollTo)
Vue.use(VueI18Next)

Vue.component('v-map', Vue2Leaflet.Map)
Vue.component('v-tilelayer', Vue2Leaflet.TileLayer)
Vue.component('v-marker', Vue2Leaflet.Marker)
Vue.component('v-tooltip', Vue2Leaflet.Tooltip)
Vue.component('v-popup', Vue2Leaflet.Popup)

const zipCodeRegex = {
  AT: /^\d{4}$/,
  BE: /^\d{4}$/,
  CH: /^\d{4}$/,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: /^\d{5}$/,
  DK: /^\d{4}$/,
  EE: /^\d{5}$/,
  ES: /^\d{5}$/,
  FI: /^\d{5}$/,
  FR: /^\d{2}[ ]?\d{3}$/,
  GB: /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/,
  HR: /^\d{5}$/,
  HU: /^\d{4}$/,
  IE: /^([AC-FHKNPRTV-Y]{1}[0-9]{2}|(?:D6W))[ -]?[0-9A-Z]{4}$/,
  IT: /^\d{5}$/,
  LV: /^([Ll][Vv][- ]{0,1}){0,3}\d{4}$/,
  LT: /^\d{5}$/,
  LU: /^\d{4}$/,
  NL: /^\d{4}(\s{0,1}[A-Za-z]{2})?$/,
  PL: /^\d{2}[- ]{0,1}\d{3}$/,
  PT: /^\d{4}[- ]{0,1}\d{3}$/,
  SK: /^\d{3}\s\d{2}$/,
  SE: /^\d{3}\s*\d{2}$/,
  SI: /^([Ss][Ii][- ]{0,1}){0,1}\d{4}$/
}

Validator.extend('orderNumberPerCountry', (nr, [countryCode]) => {
  return ['FI', 'IT'].includes(countryCode) ? nr.length <= 40 : nr.length <= 50;
}, {
  hasTarget: true
})

const blackListedZipCodes = ["35000", "35001", "35002", "35003", "35004", "35005", "35006", "35007", "35008", "35009",
  "35010", "35011", "35012", "35013", "35014", "35015", "35016", "35017", "35018", "35019", "35020", "35060", "35070",
  "35071", "35080", "35090", "35100", "35106", "35107", "35108", "35109", "35110", "35118", "35119", "35120", "35128",
  "35129", "35130", "35138", "35139", "35140", "35149", "35190", "35191", "35192", "35193", "35194", "35195", "35196",
  "35197", "35198", "35199", "35200", "35210", "35211", "35212", "35213", "35214", "35215", "35216", "35217", "35218",
  "35219", "35220", "35229", "35230", "35240", "35249", "35250", "35259", "35260", "35269", "35270", "35280", "35290",
  "35299", "35300", "35307", "35308", "35309", "35310", "35319", "35320", "35328", "35329", "35330", "35333", "35338",
  "35339", "35340", "35349", "35350", "35360", "35368", "35369", "35400", "35411", "35412", "35413", "35414", "35415",
  "35420", "35421", "35422", "35423", "35430", "35431", "35432", "35450", "35457", "35458", "35459", "35460", "35468",
  "35469", "35470", "35478", "35479", "35480", "35488", "35489", "35500", "35507", "35508", "35509", "35510", "35518",
  "35519", "35520", "35530", "35539", "35540", "35541", "35542", "35543", "35544", "35550", "35558", "35559", "35560",
  "35561", "35562", "35570", "35571", "35572", "35580", "35600", "35610", "35611", "35612", "35613", "35620", "35625",
  "35626", "35627", "35628", "35629", "35630", "35637", "35638", "35639", "35640", "35649", "35650", "35660", "35998",
  "35999", "38000", "38001", "38002", "38003", "38004", "38005", "38006", "38007", "38008", "38009", "38010", "38070",
  "38071", "38080", "38107", "38108", "38109", "38110", "38111", "38120", "38129", "38130", "38139", "38140", "38150",
  "38160", "38170", "38180", "38190", "38200", "38201", "38202", "38203", "38204", "38205", "38206", "38207", "38208",
  "38240", "38250", "38260", "38270", "38279", "38280", "38289", "38290", "38291", "38292", "38293", "38294", "38295",
  "38296", "38297", "38298", "38300", "38310", "38311", "38312", "38313", "38314", "38315", "38320", "38329", "38330",
  "38340", "38350", "38355", "38356", "38357", "38358", "38359", "38360", "38369", "38370", "38379", "38380", "38389",
  "38390", "38398", "38399", "38400", "38410", "38411", "38412", "38413", "38414", "38415", "38416", "38417", "38418",
  "38419", "38420", "38428", "38429", "38430", "38434", "38435", "38437", "38438", "38439", "38440", "38441", "38449",
  "38450", "38458", "38459", "38460", "38470", "38479", "38480", "38489", "38500", "38508", "38509", "38510", "38520",
  "38530", "38540", "38550", "38560", "38570", "38579", "38580", "38588", "38589", "38590", "38591", "38592", "38593",
  "38594", "38595", "38600", "38610", "38611", "38612", "38613", "38614", "38615", "38616", "38617", "38618", "38619",
  "38620", "38626", "38627", "38628", "38629", "38630", "38631", "38632", "38639", "38640", "38649", "38650", "38652",
  "38660", "38670", "38677", "38678", "38679", "38680", "38683", "38684", "38685", "38686", "38687", "38688", "38689",
  "38690", "38700", "38710", "38711", "38712", "38713", "38714", "38715", "38720", "38726", "38727", "38728", "38729",
  "38730", "38738", "38739", "38740", "38749", "38750", "38758", "38759", "38760", "38767", "38768", "38769", "38770",
  "38779", "38780", "38787", "38788", "38789", "38800", "38801", "38810", "38811", "38812", "38813", "38820", "38829",
  "38830", "38840", "38849", "38850", "38852", "38860", "38869", "38870", "38879", "38890", "38891", "38892", "38900",
  "38910", "38911", "38912", "38913", "38914", "38915", "38916", "38917", "38998", "38999", "60900"]

Validator.extend('fullName', (name, [countryCode]) => {
  if ((countryCode && countryCode != 'GB')) {
    const fullNameInput = name.trim();
    if (fullNameInput.length < 1 || fullNameInput.length > 120) {
      return false
    }
    return true;
  }
  return true;
}, {
  hasTarget: true
})

Validator.extend('fullNamePerCountry', (name, [countryCode]) => {
  return !((countryCode && countryCode === 'GB') && (name && name.length > 18));
}, {
  hasTarget: true
})

Validator.extend('zipCodePerCountry', (zipCode, [countryCode]) => {
  if(countryCode === 'IE') {
    zipCode = zipCode.toUpperCase();
  }
  return zipCodeRegex[countryCode].test(zipCode);
}, {
  hasTarget: true
})


Validator.extend('blackListZipCodePerCountry', (zipCode, [countryCode]) => {
  if ((countryCode && countryCode == 'ES')) {
    return !blackListedZipCodes.includes(zipCode);
  }
  return true;
}, {
  hasTarget: true
})

Validator.extend('invalidCharPerCountry', (name, [countryCode]) => {

  //Format for invalid character
  var format = /[`´]+/;

  return !((countryCode && countryCode === 'GB') && (name && format.test(name)));
}, {
  hasTarget: true
})

Validator.extend('emailInput', {
  validate: value => {
    const email = value;
    var emailRegex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;
    return emailRegex.test(email);
  }
})

on('languageChanged', lang => {
  const match = lang.match(/^[a-z]*/)

  if (match[0]) {
    Validator.localize(match[0])
  }
})

Vue.filter('distance', function (distance) {
  if (distance < 1000) {
    return distance.toFixed(0) + ' m'
  }

  return (distance / 1000).toFixed(2) + ' km'
})

i18next // eslint-disable-line import/no-named-as-default-member
  .use(i18nextLangDetect)
  .init({
    fallbackLng: {
      'de-DE': ['de'],
      default: ['de']
    },
    namespaces: ['translation', 'common'],
    defaultNS: 'translation',
    fallbackNS: 'translation',
    debug: true,
    load: 'languageOnly',
    resources: messages
  })

const i18n = new VueI18Next(i18next)

const app = new Vue({
  router,
  store,
  i18n,
  ...App
})

export { app, router, store }
export const eventBus = new Vue();



// WEBPACK FOOTER //
// ./client/app.js